/**
 * CloudFront serves the React SPA for unknown keys. Directory URLs like
 * /previews/ therefore hit NotFound unless we bounce to the real HTML file.
 * File paths (*.html, *.css) are left alone so a missing file 404s once.
 */
export function staticPreviewPath(pathname: string): string | null {
  if (!pathname.startsWith('/previews')) return null;
  const last = pathname.split('/').pop() ?? '';
  if (last.includes('.')) return null;
  return pathname.endsWith('/') ? `${pathname}index.html` : `${pathname}/index.html`;
}
